module.exports = __webpack_public_path__ + "static/helpscout2-5ef58ae2aed4d2a1c2d2e9273d7052c0.png";